
export default {
  name: 'Logo',
}
